import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { GetCaseMovementListPagingAndFilterRequest } from '../models/request/caseMovement/GetCaseMovementListPagingAndFilterRequest';

export class CaseMovementService {
    static async getCaseMovementList() {
        try {
            var inputObj = {

            };

            console.log('SERVICE CALL - getCaseMovementList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/CaseMovement/getCaseMovementList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportCaseMovementList(inputObj: GetCaseMovementListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportCaseMovementList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/CaseMovement/exportCaseMovementList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getCaseMovementListPagingAndFilter(inputObj: GetCaseMovementListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetCaseMovementListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/CaseMovement/GetCaseMovementListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addCaseMovement(_caseMovementId: string | undefined, _refNo: string | undefined, _caseMovementTypeId: string, _caseId: string, _price: string | undefined, _processDate: string | undefined, _description: string | undefined, _isCustomActive: number, _currentCompanyId: string | undefined) {
        try {

            var inputObj = {
                caseMovementId: _caseMovementId,
                refNo: _refNo,
                caseMovementTypeId: _caseMovementTypeId,
                caseId: _caseId,
                price: _price,
                processDate: _processDate,
                description: _description,
                isCustomActive: _isCustomActive,
                currentCompanyId: _currentCompanyId,
            }

            console.log('SERVICE CALL - AddCaseMovement', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/CaseMovement/AddCaseMovement', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteCaseMovement(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteCaseMovement', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/CaseMovement/deleteCaseMovement', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getCaseMovementById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getCaseMovementById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/CaseMovement/getCaseMovementById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}